import { render, staticRenderFns } from "./ModalDatosPaciente.vue?vue&type=template&id=00081962&scoped=true"
import script from "./ModalDatosPaciente.vue?vue&type=script&lang=js"
export * from "./ModalDatosPaciente.vue?vue&type=script&lang=js"
import style0 from "./ModalDatosPaciente.vue?vue&type=style&index=0&id=00081962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00081962",
  null
  
)

export default component.exports